import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useAuth } from 'auth';
import { useLocationService } from 'services/location';

export const PrivateRoute: React.FC<RouteProps> = ({
	component: Component,
	path,
	children,
	...rest
}) => {
	const { isLoading: loading, isAuthenticated, login } = useAuth();
	const location = useLocationService();

	React.useEffect(() => {
		if (loading || isAuthenticated) {
			return;
		}
		const fn = async () => {
			await login({
				appState: { targetUrl: location.getPathname() }
			});
		};
		fn();
	}, [loading, isAuthenticated, login, location, path]);

	const render: RouteProps['render'] = (props) => {
		if (isAuthenticated) {
			if (Component) {
				return <Component {...props} />;
			}

			if (children) {
				return <>{children}</>;
			}
		}

		return null;
	};

	return <Route path={path} render={render} {...rest} />;
};
